module.exports = __webpack_public_path__ + "static/media/BH.6dcdd9a1.png";